import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants";
import { UpdateFeedInsertRequestBody } from "./updateFeedInsert.types";

export const requestUpdateFeedInsert = async ({
  id,
  ...body
}: UpdateFeedInsertRequestBody): Promise<void> => {
  return await instance.patch(buildUrl(ApiRoutesContent.FeedInserts, id), body);
};
